import type { RouteType, RouteContext } from "types/RouteType";
import type { RootStore } from "@intrasync/stores";
import type NTXProductionScheduleStore from "./NTXProductionScheduleStore";

const ntxProductionScheduleRoute: RouteType[] = [
  {
    name: "Production Schedule",
    path: "/ntx-production-schedule",
    layout: "/app",
    group: "Scheduling",
    requiresAuth: true,
    requiresPermission: false,
    enableAutoFind: false,
    viewportCard: {
      header: {
        title: "Production Schedule",
        enableRefreshButton: true,
        component: () => import("./NTXProductionSchedule.Header"),
      },
      body: {
        component: () => import("./NTXProductionSchedule.Body"),
        grayBackground: true,
      },
    },
    channels: [
      "scheduling/production-schedules",
      "scheduling/sales-orders",
      "scheduling/sales-order-lines",
      "scheduling/production-departments",
      "scheduling/form-capacity",
      "manufacturing/products",
      "manufacturing/forms",
    ],
    dialogs: [
      {
        name: "scheduleStructure",
        title: "Schedule Structure",
        component: () => import("./dialogs/ScheduleStructureDialog"),
        cancelButton: false,
        height: 800,
      },
      {
        name: "pushSchedule",
        title: "Push Schedule",
        component: () => import("./dialogs/PushScheduleDialog"),
        cancelButton: false,
        height: 460,
      },
      {
        name: "confirmDeleteScheduleItem",
        title: "Remove from Schedule",
        component: () => import("./dialogs/ConfirmDeleteDialog"),
        cancelButton: false,
        height: 420,
      },
      {
        name: "publishSchedule",
        title: "Publish Customer Schedule",
        component: () => import("./dialogs/PublishScheduleDialog"),
        cancelButton: false,
        height: 640,
        maxWidth: "sm",
        fullWidth: true,
      },
      {
        name: "productDetail",
        title: "Product Detail — QC Checklist",
        component: () => import("./dialogs/ProductDetailDialog"),
        cancelButton: false,
        height: 700,
        maxWidth: "sm",
        fullWidth: true,
      },
    ],
    onEnter: async ({ rootStore }: RouteContext) => {
      const store = (rootStore as RootStore & {
        ntxProductionScheduleStore?: NTXProductionScheduleStore;
      }).ntxProductionScheduleStore;
      if (store) await store.loadData();
    },
  },
];

export default ntxProductionScheduleRoute;
